<h2 mat-dialog-title>Import GPS</h2>
<mat-dialog-content>
  <mat-stepper linear #stepper>
    <form [formGroup]="importGpsFormGroup">
      <mat-step [stepControl]="file"
                label="Plik z danymi Gps">
        <ng-template matStepContent>
          <mat-card class="width-100 mat-elevation-z0">
            <mat-card-content>
              <app-import-payments-select-file formControlName="file"
                                               class="width-100">
              </app-import-payments-select-file>
            </mat-card-content>
            <mat-card-actions>
              <button mat-raised-button
                      action-button
                      color="primary"
                      matStepperNext
                      [disabled]="importGpsFormGroup.invalid"
                      [action]="importGps.bind(this)">
                Załaduj dane Gps
              </button>
            </mat-card-actions>
          </mat-card>
        </ng-template>
      </mat-step>
    </form>
  </mat-stepper>
</mat-dialog-content>
